import { PLANS, BASE_PLAN_ALLOWED_SUBMODULES } from "constants/plans"
import { SessionDataStore } from "./authUtils"
import { isFeatureEnabledLocal } from "config/feature-flags"

function isSubModule(
	subModule: string | undefined,
	aclFeatures: { [x: string]: any }
) {
	return subModule && aclFeatures
}

const getFeatureFlagsAuthorization = (
	subModule: string | undefined,
	aclFeatures: any,
	module: string
) => {
	return isSubModule(subModule, aclFeatures)
		? aclFeatures[module]?.find((feature: string) => feature === subModule)
		: aclFeatures[module]
}

export const hasUserAccess = (policiesModule?: string[]) => {
	if (!policiesModule) return true

	const userRoles = SessionDataStore.getInstance().getRoles()

	return policiesModule.some((policy) => userRoles.includes(policy))
}

export const isAccessPrivileges = (
	module: string,
	subModule?: string,
	policies?: string[]
) => {
	if (isFeatureEnabledLocal()) return true
	const aclFeatures = SessionDataStore.getInstance().getFeatures()
	return (
		getFeatureFlagsAuthorization(subModule, aclFeatures, module) &&
		hasUserAccess(policies)
	)
}

export const hasAccessByPlan = (submodule: string) => {
	const userPlan = SessionDataStore.getInstance().getPlans()

	if (userPlan.includes(PLANS.FULL_PLAN)) {
		return true
	}

	if (userPlan.includes(PLANS.BASE_PLAN)) {
		return BASE_PLAN_ALLOWED_SUBMODULES.includes(submodule)
	}

	return false
}
